// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"cadae77a","647":"2b5b5ced"}[chunkId] + ".chunk.js";
};